Ext.define('SA.VectorMapExportCroppingWindow', {
    alias: 'widget.vector-map-export-cropping-window',
    extend: 'Ext.Container',

    statics: {
        computeFitSize() {
            var El = Ext.dom.Element,
                constrain = Ext.Number.constrain;

            return {
                height: constrain(El.getViewportHeight() - 20, 520, 700),
                width: constrain(El.getViewportWidth() - 20, 650, 1200)
            };
        }
    },

    autoShow: true,
    cls: 'sa-map-export sa-map-export-cropping',
    floating: true,
    hideMode: 'visibility',
    modal: true,

    layout: {
        align: 'stretch',
        type: 'vbox'
    },

    initComponent() {
        var map = this.map,
            extent = SA.model.map.Extent.fromBounds(map.getExtent().toXYBounds()),
            cropExtent = extent.clone(),
            totalExtent = extent.clone(),
            details;

        cropExtent.setSize(SA.restrictSizeByRatio(cropExtent.getSize(), 8.5 / 11));

        totalExtent.setHeight(totalExtent.getHeight() * 1.1);
        totalExtent.setWidth(totalExtent.getWidth() * 1.1);

        details = this.details = Ext.create('SA.model.map.Export', {
            extent: cropExtent,

            insetMap: {
                visible: false,
                width: 0.2,
                x: 0.9,
                y: 0.875
            },

            legend: {
                aspectRatio: 0.75,
                visible: map.getAttribute() || map.getBusinessSearch(),
                width: 0.2,
                x: 0.9,
                y: 0.1
            },

            map: {
                visible: true,
                x: 0.5,
                y: 0.5
            },

            northArrow: {
                aspectRatio: 2,
                visible: false,
                width: 0.05,
                x: 0.1,
                y: 0.1
            },

            scaleBar: {
                aspectRatio: 0.175,
                visible: true,
                width: 0.125,
                x: 0.1,
                y: 0.9
            }
        });

        this.items = [
            {
                xtype: 'simple-container',
                cls: 'sa-map-export-header',

                items: [
                    {
                        xtype: 'component',
                        html: 'Export Map \u2013 Cropping'
                    }, {
                        xtype: 'close-button'
                    }
                ]
            }, {
                xtype: 'container',
                flex: 1,
                padding: '9 14',

                layout: {
                    align: 'stretch',
                    type: 'hbox'
                },

                items: [
                    {
                        xtype: 'container',
                        margin: '0 14 0 0',
                        width: 263,

                        items: [
                            {
                                xtype: 'component',
                                cls: 'sa-map-export-instructions',
                                margin: '0 0 12',

                                html: [
                                    '<div class="sa-map-export-instructions-title">',
                                        '<svg class="sa-map-export-step-icon">',
                                            '<use href="#sa-icon-step-1"></use>',
                                        '</svg>',
                                        'Stage 1 of 3 \u2013 Cropping',
                                    '</div>',
                                    '<div>Cropping allows you to select which region of the map you’d like to export.</div>'
                                ]
                            }, {
                                xtype: 'vector-map-export-crop-aspect-ratio-fieldset'
                            }
                        ],

                        layout: {
                            align: 'stretch',
                            type: 'vbox'
                        }
                    }, {
                        xtype: 'vector-map-export-crop-preview',
                        details,
                        extent: totalExtent,
                        flex: 1,
                        map
                    }
                ]
            }, {
                xtype: 'simple-container',
                cls: 'sa-map-export-footer',

                items: [
                    {
                        xtype: 'sa-button',
                        itemId: 'continue',
                        text: 'Continue to Layout',
                        ui: 'primary'
                    }, {
                        xtype: 'sa-button',
                        itemId: 'cancelButton',
                        text: 'Cancel'
                    }
                ]
            }
        ];

        this.callParent();

        this.aspectRatioFieldSet = this.down('vector-map-export-crop-aspect-ratio-fieldset');
        this.cancelButton = this.down('#cancelButton');
        this.continueButton = this.down('#continue');
    },

    afterHide() {
        this.query('[floating]').forEach(item => {
            if (item.isVisible()) {
                item.hide();
            }
        });

        this.callParent(arguments);
    },

    beforeDestroy() {
        this.callParent();

        this.mun(SA.Viewport, 'resize', this.refreshSizeAndCenter, this);
    },

    initEvents() {
        this.callParent();

        this.mon(SA.Viewport, 'resize', this.refreshSizeAndCenter, this);

        this.aspectRatioFieldSet.on('change', fieldSet => this.fireEvent('change:aspectRatio', fieldSet));
        this.aspectRatioFieldSet.on('collapse', fieldSet => this.fireEvent('collapse:aspectRatio', fieldSet));
        this.aspectRatioFieldSet.on('expand', fieldSet => this.fireEvent('expand:aspectRatio', fieldSet));
        this.cancelButton.on('click', () => this.destroy());
        this.continueButton.on('click', button => this.fireEvent('click:continue', button));
    },

    onShow() {
        this.callParent();

        this.refreshSizeAndCenter();
    },

    refreshSizeAndCenter() {
        var body = Ext.getBody(),
            size = this.self.computeFitSize(),
            xy;

        Ext.suspendLayouts();

        this.setWidth(size.width);
        this.setHeight(size.height);

        Ext.resumeLayouts(true);

        xy = this.getAlignToXY(body, 'c-c?');

        this.setPagePosition(xy);
    }
});